import { Button } from '@jouzen/ecom-components/v3/Button';
import type { StockStatus } from '@jouzen/ecom-components/v3/types/stockStatus';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import useAddToCart from '@/app/[locale]/product/_hooks/useAddToCart';

export interface BundleFixedFooterProps {
  readonly hasMaxRingCount: boolean | undefined;
  readonly isAddingToCart: boolean | undefined;
  readonly modalButtonText:
    | 'pdp_add_to_cart'
    | 'bundle_modal_skip_button'
    | 'bundle_cta_update_cart';
  readonly nextButtonDisabled: boolean | undefined;
  readonly ringCount: number | undefined;
  readonly stockStatus: StockStatus;
}

const BundleFixedFooter = ({
  hasMaxRingCount,
  isAddingToCart,
  modalButtonText,
  nextButtonDisabled,
  ringCount,
  stockStatus,
}: BundleFixedFooterProps) => {
  const t = useTranslations();
  const wizardContext = useWizardStateContext();
  const { onAddToCart } = useAddToCart({ ...wizardContext, stockStatus });

  return (
    <div
      className="flex justify-end border-t border-sandstone-500/50 bg-sandstone-100 pt-4"
      data-cy="bundle-fixed-footer"
    >
      {hasMaxRingCount ? (
        <Button
          className="w-full"
          data-cy="multi-ring-max-cart"
          href="/cart"
          variant="secondary-dark"
        >
          {t('view_your_cart')}&nbsp;
          <span>{`( ${ringCount} )`}</span>
        </Button>
      ) : (
        <Button
          className={cx('border-[1px] border-solid border-sandstone-500', {
            'bg-[#4A4741]/8 text-sandstone-500 md:bg-transparent md:hover:bg-[#4A4741]/8':
              modalButtonText === 'bundle_modal_skip_button',
          })}
          data-cy={`bundle_${modalButtonText}`}
          disabled={nextButtonDisabled}
          loading={isAddingToCart}
          loadingTextEnabled
          size="large"
          type="submit"
          variant="secondary-dark"
          onClick={onAddToCart}
        >
          {t(modalButtonText)}
        </Button>
      )}
    </div>
  );
};
export default BundleFixedFooter;
